import { Streamdown } from "streamdown";

export type MarkdownPreviewProps = { markdown: string };

/**
 * Presentational Markdown renderer. Uses Streamdown, which is hardened by
 * default: it blocks images/links from unexpected origins and shows a
 * link-safety prompt before navigation — safe for untrusted content. The
 * consumer passes the already-loaded markdown string.
 */
export const MarkdownPreview = ({ markdown }: MarkdownPreviewProps) => {
  // Streamdown ships its own Tailwind utility classes (no typography plugin
  // needed); the consuming app's tailwind scans streamdown/dist to generate them.
  return (
    <div className="max-w-none overflow-auto p-4 text-sm text-gray-800">
      <Streamdown>{markdown}</Streamdown>
    </div>
  );
};
